import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import SelectorImage from "../../form/SelectorGrid/SelectorImage";
import Dropzone from "react-dropzone";
import {fileUpload} from "../../../utils/request";
import Button from "../../form/Button";
import FolderButton from "./figure/FolderButton";

class figureGallery extends React.Component {

    onDrop = async (acceptedFiles) => {
        try {
            /*const response = */ await fileUpload({
                files: acceptedFiles,
                action: this.props.componentConfig.componentname + ".bulkCreate",
                component: this.props.values.component || this.props.component,
                component_id: this.props.values.componentId || this.props.componentId
            });
            this.refresh();
        } catch (e) {
            console.error(e);
        }
    }

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    openDialog = () => {
        if (this.dropzoneRef) {
            this.dropzoneRef.open();
        }
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading} = this.props;
        if (this.props.component && this.props.componentId) {
            filter = filter || [];
            if (!Array.isArray(filter)) {
                filter = [filter];
            }
            filter.push({field: "component", value: this.props.component});
            filter.push({field: "component_id", value: this.props.componentId});
        }
        const props = {componentConfig, filter, loading: isLoading, pageSize: this.props.pageSize !== undefined ? this.props.pageSize : 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <Dropzone disableClick className="image-pool" ref={(node) => { this.dropzoneRef = node; }} onDrop={this.onDrop}>
                <SelectorGrid
                    type={SelectorImage}
                    ref={(el) => this.list = el}
                    paginatorRight={(props) => <Fragment>
                        <FolderButton
                            {...props}
                            component={this.props.values.component || this.props.component}
                            component_id={this.props.values.componentId || this.props.componentId}
                            onComplete={() => {
                                this.list && this.list.refresh();
                            }}
                        />
                        <Button
                            {...props}
                            onClick={this.openDialog}
                            icon={{lib: "fa", name: "upload"}}
                        />
                    </Fragment>}
                    gridid={this.props.gridid !== undefined ? this.props.gridid : "figureGallery"}
                    {...props}
                    columns={{
                        "id": {header: 'Kód', width: 3, sortable, filterable},
                        "path": {header: 'Útvonal', width: 3, sortable, filterable},
                        "name": {header: 'Név', width: 3, sortable, filterable},
                        "url": {header: 'Url', width: 3, sortable, filterable},
                    }}
                    orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                    selection={selection}
                    onSelectionChange={(selection) => this.props.loadForm(selection.value)}
                />
            </Dropzone>
        );
    }
}

export default figureGallery;
